/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Preview_TitleInputs */

const en_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR Preview Setup`)
};

const fr_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration de l'aperçu ADR`)
};

const de_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Vorschau-Setup`)
};

const it_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione dell'anteprima ADR`)
};

const ru_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр ADR`)
};

const es_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de vista previa de ADR`)
};

const zh_cn2_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR预览设置`)
};

const ja_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRプレビュー設定`)
};

const hi_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर पूर्वावलोकन सेटअप`)
};

const pt_pt2_options_adr_preview_title = /** @type {(inputs: Options_Adr_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração de pré-visualização de ADR`)
};

/**
* | output |
* | --- |
* | "ADR Preview Setup" |
*
* @param {Options_Adr_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_preview_title = /** @type {((inputs?: Options_Adr_Preview_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Preview_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_preview_title(inputs)
	if (locale === "de") return de_options_adr_preview_title(inputs)
	if (locale === "it") return it_options_adr_preview_title(inputs)
	if (locale === "ru") return ru_options_adr_preview_title(inputs)
	if (locale === "es") return es_options_adr_preview_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_preview_title(inputs)
	if (locale === "ja") return ja_options_adr_preview_title(inputs)
	if (locale === "hi") return hi_options_adr_preview_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_preview_title(inputs)
	return en_options_adr_preview_title(inputs)
});